import type { SvgIconProps } from '@mui/material/SvgIcon';
import { createElement, type ComponentType } from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import BackpackOutlinedIcon from '@mui/icons-material/BackpackOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import DirectionsBusOutlinedIcon from '@mui/icons-material/DirectionsBusOutlined';
import FamilyRestroomOutlinedIcon from '@mui/icons-material/FamilyRestroomOutlined';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';

/**
 * Fabrica's role icons by their MUI icon name (Roles.Icon, e.g. `LocalLibraryOutlined`). Icons are
 * imported one by one to keep the bundle small, so a name not listed here shows the generic icon;
 * add a name here when Fabrica gives a role a new one.
 */
const ICONS: Record<string, ComponentType<SvgIconProps>> = {
  AccountCircleOutlined: AccountCircleOutlinedIcon,
  AdminPanelSettingsOutlined: AdminPanelSettingsOutlinedIcon,
  ApartmentOutlined: ApartmentOutlinedIcon,
  BackpackOutlined: BackpackOutlinedIcon,
  BadgeOutlined: BadgeOutlinedIcon,
  CastForEducationOutlined: CastForEducationOutlinedIcon,
  DirectionsBusOutlined: DirectionsBusOutlinedIcon,
  FamilyRestroomOutlined: FamilyRestroomOutlinedIcon,
  HotelOutlined: HotelOutlinedIcon,
  HowToRegOutlined: HowToRegOutlinedIcon,
  LocalLibraryOutlined: LocalLibraryOutlinedIcon,
  PaymentsOutlined: PaymentsOutlinedIcon,
  PersonOutlined: PersonOutlinedIcon,
  PointOfSaleOutlined: PointOfSaleOutlinedIcon,
  SchoolOutlined: SchoolOutlinedIcon,
  SupervisorAccountOutlined: SupervisorAccountOutlinedIcon,
  WorkspacePremiumOutlined: WorkspacePremiumOutlinedIcon,
};

/** The icon component Fabrica names (`Icon` suffix optional); the generic person icon for none or an unknown name. */
function roleIconOf(name: string | null | undefined): ComponentType<SvgIconProps> {
  const key = name?.trim().replace(/Icon$/, '') ?? '';
  return ICONS[key] ?? PersonOutlinedIcon;
}

/** A role's icon from its Fabrica icon name, falling back to a generic person icon. */
export function RoleIcon({ icon, ...props }: Omit<SvgIconProps, 'name'> & { icon: string | null | undefined }) {
  return createElement(roleIconOf(icon), props);
}
